import { makeAutoObservable } from 'mobx';
import configurationStore from 'common/stores/configuration/configuration.store';
import { ILiveActivity } from './live-activity.types';
import liveActivityService from 'common/services/live-activity-service/live-activity-service';

class EIQSecureLiveActivityStore {
  liveActivityLogs: ILiveActivity[];

  constructor() {
    this.liveActivityLogs = [];

    makeAutoObservable(this);
  }

  async init() {
    const gate = configurationStore.currentUserGate;
    const result = await liveActivityService.getLastLiveActivityByGate(gate?.name);
    this.liveActivityLogs = [...result];
  }

  addRecord(log: ILiveActivity) {
    const exists = this.liveActivityLogs.some((i) => i.id === log.id);
    if (exists) {
      return;
    }

    if (this.liveActivityLogs.length >= 100) {
      this.liveActivityLogs.pop();
    }
    this.liveActivityLogs.unshift(log);
  }
}

const eiqSecureLiveActivityStore = new EIQSecureLiveActivityStore();
export default eiqSecureLiveActivityStore;
